import { useState, useEffect } from 'react';
import { Field, useFormikContext } from 'formik';
import { v4 as uuidv4 } from 'uuid';

import { DeleteDialogUI, FileTabUI, FormErrorUI, FormLabelUI, InputUI, TabsUI } from '../Interface';
import DocumentLine from './DocumentLine';
import DocumentDescription from './DocumentDescription';
import DocumenLogistics from './DocumenLogistics';
import DocumentAdditional from './DocumentAdditional';
import DocumentSum from './DocumentSum';
import jokerService from '../../service/joker.service';
import JokerTab from '../Interface/Joker/JokerTab';
import { set } from 'lodash';

const CompanyWarningPanel = ({ disabled }) => {
  const { values, errors } = useFormikContext();

  return (
    <div>
      <div className="col-span-full relative">
        <div className="mt-2">
          <Field
            type="text"
            name="companyWarning"
            as={InputUI}
            className={`${disabled ? 'rounded-md' : ''} resize-none h-36, p-2`}
            fullWidth
            label={<FormLabelUI text="Figyelmeztetés" />}
            variant="standard"
            helperText={<FormErrorUI message={errors.companyWarning} />}
            disabled={disabled}
            InputLabelProps={{ shrink: values.companyWarning !== '' }}
            multiline
            rows={10}
          />
        </div>
      </div>
    </div>
  );
};

const DocumentTabs = (props) => {
  const { newFilesState, disabled } = props;
  const { newFiles, setNewFiles } = newFilesState;
  const { values, setFieldValue } = useFormikContext();
  const [fileToDelete, setFileToDelete] = useState(null);
  const [activeTab, setActiveTab] = useState(0);

  const [jokerGroups, setJokerGroups] = useState([]);

  const getJokerGroups = async () => {
    jokerService.getGroups(props.upperDocType).then((data) => {
      setJokerGroups(data);
    });
  };

  useEffect(() => {
    getJokerGroups();
  }, []);

  const handleUpload = (files) => {
    const filesWithId = files.map((file) => {
      file.id = uuidv4();
      return file;
    });

    const updatedAttachments = (values.attachment || []).filter(
      (attachment) => !filesWithId.some((file) => file.name === attachment.name)
    );
    setFieldValue('attachment', updatedAttachments);

    const existingFiles = newFiles.filter(
      (existingFile) => !filesWithId.some((file) => file.name === existingFile.name)
    );

    setNewFiles([...existingFiles, ...filesWithId]);
  };

  const hideDeleteDialog = () => {
    setFileToDelete(null);
  };

  const handleRemoveElement = () => {
    setNewFiles((prevFiles) => prevFiles.filter((file) => file.id !== fileToDelete));
    setFieldValue(
      'attachment',
      (values.attachment || []).filter((attachment) => attachment.id !== fileToDelete)
    );

    hideDeleteDialog();
  };

  const tabs = [
    {
      id: 0,
      name: 'Tétel',
      content: <DocumentLine {...props} />,
    },
    {
      id: 1,
      name: 'Logisztika',
      content: <DocumenLogistics {...props} />,
    },
    {
      id: 2,
      name: 'További adatok',
      content: <DocumentAdditional {...props} />,
    },
    {
      id: 3,
      name: 'Megjegyzés',
      content: <DocumentDescription {...props} />,
    },

    {
      id: 4,
      name: 'Összesen',
      content: <DocumentSum {...props} />,
    },
    {
      id: 5,
      name: 'Csatolmányok',
      content: (
        <FileTabUI
          disabled={disabled}
          savedFiles={[...(values?.attachment || []), ...newFiles]}
          handleUpload={handleUpload}
          handleDelete={(item) => setFileToDelete(item.id)}
          showUpdatedAt={true}
        />
      ),
    },
    {
      id: 6,
      name: 'Figyelmeztetés',
      content: <CompanyWarningPanel {...props} />,
    },
    ...((jokerGroups.length > 0 &&
      jokerGroups.map((group, index) => ({
        id: index + 4,
        name: group.name,
        content: <JokerTab fields={group.jokerFields} key={index} {...props} />,
      }))) ||
      []),
  ];

  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
  };

  return (
    <>
      <div className="my-4">
        <div className="px-3">
          <TabsUI activeTab={activeTab} handleTabClick={handleTabClick}>
            {tabs.map((tab, index) => (
              <div key={index} name={tab.name}>
                {tab.content}
              </div>
            ))}
          </TabsUI>
        </div>
      </div>
      <DeleteDialogUI
        handleRemoveElement={handleRemoveElement}
        show={fileToDelete}
        onHide={() => {
          hideDeleteDialog();
        }}
      />
    </>
  );
};

export default DocumentTabs;
